import { RelatedProductsAccordion } from 'components/Product';
import { PRODUCT_DETAILS_BELONGS_TO_BUNDLE_ID } from 'constants/ids';
import type { VariantId } from 'models/product';

import { useBelongsToBundleContext } from '../ProductDetailsContext';

interface Props {
	contentClassName: string;
	expiredProductsTitle: string;
	loadMoreButtonText: string;
	noProductsText: string;
	title: string;
	variantId: VariantId;
}

export default function BelongsToBundleAccordion({
	contentClassName,
	expiredProductsTitle,
	loadMoreButtonText,
	noProductsText,
	title,
	variantId,
}: Props) {
	const {
		hasNextPage,
		isLoading,
		isLoadingMore,
		isOpen,
		items,
		loadMore,
		toggleOpen,
	} = useBelongsToBundleContext();
	return (
		<RelatedProductsAccordion
			title={title}
			accordionId={PRODUCT_DETAILS_BELONGS_TO_BUNDLE_ID}
			expiredProductsTitle={expiredProductsTitle}
			loadMoreButtonText={loadMoreButtonText}
			gtmItemListId="pdp_belongs_to_bundle"
			gtmItemListName={`List: Belongs to bundle ${variantId}`}
			noProductsText={noProductsText}
			products={items}
			isLoadingInitial={isLoading}
			isLoadingMore={isLoadingMore}
			hasNextPage={hasNextPage}
			onLoadMoreClick={loadMore}
			contentClassName={contentClassName}
			isOpen={isOpen}
			onClick={toggleOpen}
		/>
	);
}

BelongsToBundleAccordion.displayName = 'BelongsToBundleAccordion';
